import { ClipboardCheckOutlineIcon } from './ClipboardCheckOutlineIcon';

/**
 * author: James Coyle
 * id 6A0DFB73-2DBF-4D3C-8C6B-2B4758B11782
 * name clipboard-check-outline
 * version: 2.2.43
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/clipboard-check-outline.svg
 * tags
 */
export const ClipboardTickOutlineIcon = ClipboardCheckOutlineIcon;
export default ClipboardTickOutlineIcon